import { useEffect } from "react";
import { motion } from "framer-motion";
import Lenis from "lenis";

export const SmoothScroll = () => {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let frame;
    const raf = (time) => { lenis.raf(time); frame = requestAnimationFrame(raf); };
    frame = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(frame); lenis.destroy(); };
  }, []);
  return null;
};

export const Reveal = ({ children, className = "", delay = 0 }) => (
  <motion.div className={className} initial={{ opacity: 0, y: 36 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: .8, delay, ease: [.22, 1, .36, 1] }}>{children}</motion.div>
);

export const LineReveal = ({ children, delay = 0 }) => (
  <span className="line-mask"><motion.span initial={{ y: "110%" }} animate={{ y: 0 }} transition={{ duration: .95, delay, ease: [.16, 1, .3, 1] }}>{children}</motion.span></span>
);

export const Eyebrow = ({ children, light = false }) => <div className={`eyebrow ${light ? "eyebrow--light" : ""}`}><i />{children}</div>;